import { get } from '@/services/httpMethods'
import type { ApiResponse } from '@/types/api'
import type { Doctor } from '@/types/doctor'

export interface DoctorQuery {
  page?: number
  limit?: number
  search?: string
  departmentId?: string
  designationId?: string
  specializationId?: string
  status?: 'active' | 'inactive'
  showOnWebsite?: boolean
}

/** Public doctor directory. Endpoint: GET /api/v1/doctors */
export function fetchDoctors(params: DoctorQuery = {}) {
  return get<Doctor[]>('/doctors', {
    params: { page: 1, limit: 100, ...params },
  })
}

export type DoctorsResponse = ApiResponse<Doctor[]>
